import actions from '../../actionTypes';

export default msg => {
  return {
    type: actions.UPDATE_ERROR_MESSAGE,
    msg
  };
};



// WEBPACK FOOTER //
// ./src/reducers/error-banner/actions/updateErrorMsg.js